import { useEffect } from "react";

function MessageTemplate({message, setMessage}) {

  useEffect(() => {
    const timer = setTimeout(() => {
      setMessage(null);
    }, message?.timeout || 5000);

    return () => {
      clearTimeout(timer);
    };
  }, [message, setMessage]);

  const containerStyle = {
    position: 'absolute',
    right: 12,
    bottom: 11,
    backgroundColor:
      message?.type?.toLowerCase() === 'success' ? '#00C853' : '#FF1744',
    borderRadius: 10,
    zIndex: 99999,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    padding: 10,
  };

  const textContainerStyle = {
    padding: 10,
  };


  if (!message) {
    return null;
  }
  // return (<div style={{position:'fixed',right:5,bottom:5,backgroundColor:"#09b14c",color:"white",padding:7}}>{message}</div>);
  return (
    <div style={containerStyle}>
      <div style={textContainerStyle}>
        {/* <Text style={textStyle}>
          {message?.type?.toLowerCase() === 'success' ? 'Success' : 'Error'}
        </Text> */}
        <div style={{color: 'white', fontSize: 16}}>
          {message?.text || message}
        </div>
      </div>
      
    </div>
  );
}

export default MessageTemplate;
